export default __webpack_public_path__ + "static/media/buddy system.53fffc46.svg";